<template>
  <o-view>
    <o-nav-bar title="Algemene voorwaarden" :has-back-button="true" />
    <o-section>
      <p>
        <strong
          >Lees de <a href="#">gebruiksvoorwaarden van Olympus Mobility</a> om
          een ticket te kopen. Bevestig voor akkoord.</strong
        >
      </p>
      <o-checkbox name="akkoord">
        <p>
          Ik verklaar kennis te hebben genomen van de gebruiksvoorwaarden van
          Olympus Mobility. Ik aanvaard de toepassing ervan.
        </p>
      </o-checkbox>
    </o-section>
    <o-pay-button label="Volgende" to="/" />
  </o-view>
</template>

<script>
import OPayButton from '@/components/OPayButton.vue'
export default {
  name: 'ConsentOlympus',
  components: {
    OPayButton
  }
}
</script>
